import { useQuery } from "@tanstack/react-query";
import { IAdminGetUserResponse, getUser } from "../clients/admin-client";

export const useUser = (userId: string | undefined) => {
    return useQuery<IAdminGetUserResponse>(["user", userId], () => getUser(userId ?? ""), {
      enabled: !!userId,
    });
  };